package at.theatervogelweide.admin.contract

import kotlinx.rpc.annotations.Rpc
import kotlinx.serialization.Serializable

/** What the web app needs to know about the server it talks to, loaded once per sign-in. */
@Rpc
interface ServerInfoService {
    suspend fun serverInfo(): AdminResult<ServerInfo>
}

@Serializable
data class ServerInfo(
    val version: String,
    /**
     * The public site of the same environment, without a trailing slash, e.g. `https://staging.theater-vogelweide.at`.
     * It comes from the server's configuration, because one web bundle serves staging and production (#64).
     */
    val publicSiteUrl: String,
    /**
     * The new public site (beta) of the same environment in the same form, until the switch-over (#115); `null` while
     * the server has none configured (#144).
     */
    val betaSiteUrl: String? = null,
)
